import './large_quote.scss';
